
<template>
  <div> 
    <dialog-loading v-if="loading.deleting" loadingText='Apagando...'></dialog-loading>
    <DialogAddDefaultClientPayment 
      :dialog="dialog" 
      @updated="getData" 
      :default_client_payment_edit="default_client_payment"
      @closeDialog="handleCloseDialog"
      :client_payments="default_client_payments"
      v-if="dialog"
    ></DialogAddDefaultClientPayment>
    <v-data-table :loading="loading.default_client_payments" :headers="headers" :items="default_client_payments">
      <template v-slot:top>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click="dialog = !dialog">
            <v-icon small left>mdi-plus</v-icon>
            <span>FORMA</span>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.index="{item, index}">
        {{ index + 1 }}
      </template>
      <template v-slot:item.actions="{item}">
        <div class="ml-n3">
          <v-btn icon small @click="deleteDefaultClientPayment(item.id)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
          <v-btn icon small @click="editDefaultClientPayment(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'ClientDefaultPayment',
  components: {
    DialogAddDefaultClientPayment: () => import("@/_backoffice/_registrations/components/client/show/edit/DialogAddDefaultClientPayment.vue")
  },
  data() {
    return {
      dialog: false,
      default_client_payments:[],
      default_client_payment:null,
      headers:[
        { text:"Nº", value:"index" },
        { text:"Forma de pagamento", value:"payment_option.description" },
        { text:"Prazo de pagamento", value:"payment_time.description" },
        { text:"%", value:"percentage" },
        { text:"Ações", value:"actions", align: 'center'},
      ],
      loading:{
        default_client_payments: false,
        deleting: false,
      },
    }
  },
  methods: {
    handleCloseDialog(){
      this.dialog = !this.dialog
      this.default_client_payment = null
    },
    getData() {
      this.getDefaultClientPayments()
    },
    getDefaultClientPayments(){
      this.loading.default_client_payments = true
      let params = {client_id: this.$route.params.id}
      Api.DefaultClientPayment.index(params).then(res => {
        this.default_client_payments = [...res.data]
      }).finally(()=>{
        this.loading.default_client_payments = false
      })
    },
    deleteDefaultClientPayment(id){
      this.swallConfirmation({
          title: 'Deseja APAGAR método padrão de pagamento?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.loading.deleting = true
            Api.DefaultClientPayment.delete(id).then(()=>{
              this.successSaved()
              this.getData()
            }).finally(()=>{
              this.loading.deleting = false
            })
          }
        })   
    },
    editDefaultClientPayment(item){
      this.dialog = true
      this.default_client_payment = item
    }
  },
  computed: {
    ...mapState({
      oneClient: state => state.Client.oneClient,
    })
  },
  mounted() {
    this.getData()
  },
}
</script>